import templateUrl from './leads-conversion-detail-report.component.html';
import { IQService } from 'angular';
import { UtilityService } from '../../../../core/services/utility.service';
import { LeadsService } from '../../../../core/services';
import { RogersLeadsConversionDetailAggregate } from '@herbjoy/apex-api-models';

interface Filters {
    status?: any;
    agent?: any;
    team?: any;
    address?: any;
}

interface LeadDetailAggregateVM extends RogersLeadsConversionDetailAggregate {
    AgentName: string;
    StreetAddress: string;
}

export const LeadsConversionDetailReportComponent = {
    controllerAs: "vm",
    templateUrl,
    bindings: {
        mapAreaCode: "@"
    },
    controller: class LeadsConversionDetailReportController {
        report: any;
        constructor(private $q: IQService, private apexApiUrl: string, private leadsService: LeadsService,
            private utilityService: UtilityService) {
            'ngInject';
        }

        filters: Filters = {};
        leads: LeadDetailAggregateVM[];
        filteredLeads: LeadDetailAggregateVM[];
        loaded = false;
        mapAreaCode: string;
        pageNumber = 1;
        pageSize = 100;

        $onInit() {
            const initialDataLoaded = this.loadInitialData();
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(initialDataLoaded, "Initial load failed"))
                .then(() => {
                    this.loaded = true;
                });
        }

        onChangeFilters() {
            this.filteredLeads = this.leads.filter(lead => this.filterLead(lead));
        }

        onExport() {
            // eslint-disable-next-line max-len
            window.location.href = `${this.apexApiUrl}reports/leads-conversion-detail.xlsx?mapareacode=${this.mapAreaCode}`;
        }

        private loadInitialData() {
            const reportLoaded = this.leadsService.retrieveLeadsConversionDetailReport({
                mapAreaCode: this.mapAreaCode
            }).then(report => {
                this.report = report;
                this.leads = report.LeadConversionDetails.map(lead => ({
                    ...lead,
                    AgentName: lead.Agents.join(", "),
                    StreetAddress: [
                        lead.Address.StreetLine1,
                        lead.Address.StreetLine2,
                        lead.Address.City,
                        lead.Address.StateName
                    ].filter(function (component) {
                        return !!component;
                    }).join(", ")
                }));
                this.filteredLeads = this.leads.filter(lead => this.filterLead(lead));
            });

            return this.$q.all([reportLoaded]);
        }

        private filterLead(lead) {
            return (!this.filters.address
                || this.utilityService.containsInvariant(lead.StreetAddress, this.filters.address))
                && (!this.filters.team
                    || this.utilityService.containsInvariant(lead.Territory, this.filters.team))
                && (!this.filters.agent
                    || this.utilityService.containsInvariant(lead.AgentName, this.filters.agent))
                && (!this.filters.status
                    || this.utilityService.containsInvariant(lead.LeadStatus, this.filters.status));
        }
    }
};
